import script from "./PartnersFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersFooter.vue?vue&type=script&setup=true&lang=js"

import "./PartnersFooter.vue?vue&type=style&index=0&id=6534a4de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6534a4de"]])

export default __exports__